'use client';

import CommonModal from '@/components/CommonModal';
import { COMMON_MODAL_ICONS } from '@/components/CommonModal/constants';
import { useTranslation } from '@/i18n/client';

interface IBriefInitTipProps {
  open: boolean;
  onClose: () => void;
  footer?: React.ReactNode;
}

export default function BriefInitTip(props: IBriefInitTipProps) {
  const { open, onClose, footer } = props;

  const { t } = useTranslation();

  return (
    <CommonModal
      content={t('homepageEdit.downloadAppNormal')}
      footer={footer}
      icon={COMMON_MODAL_ICONS.CHAHUA}
      onClose={onClose}
      open={open}
    />
  );
}
